import React from "react";
import { nanoid } from "nanoid";

const Tiles = ({ title, tilesData }) => {
	return (
		<div className="tiles">
			<header className="tiles__head">
				<h2>{title}</h2>
			</header>

			<div className="tiles__body">
				<div className="grid">
					{tilesData.map((tile) => {
						const { title, text } = tile;

						return (
							<div
								className="grid__col grid__col--1of3"
								key={nanoid()}
							>
								<div className="tile">
									<h1>{title}</h1>

									<p>{text}</p>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default Tiles;
